import 'htmx.org';
import Alpine from 'alpinejs';

import '../components/alpine/tabs';
import '../components/miako/alpine/miakoHandler';

window.Alpine = Alpine;
Alpine.start();

window.htmx = require('htmx.org');

import '../components/miako/ceiling';

import '@iframe-resizer/child';
